// angular
// 	.module("HeroPRO")
// 	.controller("LeadController", leadController);

import _ from 'lodash';
import './lead.scss';
import './results/leadResult.scss';
import './walkthrough/leadWalkthrough.scss';

/* @ngInject */
export default function leadController(
    LeadFactory, $stateParams, $window, HPConfig, $scope, ModalService, $analytics, UserData, HPGeoStates, $timeout,
    UiDisplayFactory, PartnerAppsFactory, PermissionsFactory,
) {
    const vm = this;
    let prequalId;

    vm.isFullPrequal = false;
    vm.isOpen = true;
    vm.leadData = {};
    vm.showLeadMessage = false;
    vm.leadMessage = {};
    vm.kbygModalOpen = false;
    vm.leadResult = '';
    vm.primaryInformationLoading = true;
    vm.primaryInformationSticky = false;
    vm.loading = false;
    vm.displayActions = true;
    vm.proposalPlusEnabled = false;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');

    vm.stages = [];

    init(vm.proposalPlusEnabled = PermissionsFactory.hasPermission('ProposalPlus.Enabled'));

    $scope.$watch(() => {
        if ($scope.kbygModal !== undefined) {
            return $scope.kbygModal.kbygResponse;
        }
    }, () => {
        init();
    });

    /*= =======================================
   =            Public Functions            =
   ======================================== */
    vm.scrollPointTriggered = function (distance, element, edge) {
        vm.primaryInformationSticky = (edge !== undefined);
        // Need to force a digest here so that the $observe in primaryInformationDirective is triggered
        $scope.$digest();
    };

    vm.participatingCitiesClick = function () {
        $window.location.href = `${HPConfig.renovateLink}communities`;
    };

    vm.proPitchClick = function (params) {
        const label = (vm.kbygModalOpen === true) ? 'KBYG' : 'Leads';
        if (vm.proposalPlusEnabled === true) {
            $analytics.eventTrack('Proposal Plus Open', { category: params.source, label });
            $window.open(PartnerAppsFactory.getProPitchLink(), '_blank');
        } else {
            $analytics.eventTrack('Financing Tab Open');
            $window.location.href = '/accounts/financing/';
            // $analytics.eventTrack('Calculator Open', { category: params.source, label });
            // $window.open(PartnerAppsFactory.getHeroCalcLink(), '_blank');
        }
    };

    vm.applyNowClick = function (params) {
        if (vm.isFullPrequal) {
            const input = btoa(`${vm.leadData.RAApplicationID}|${vm.leadData.AllOwners}`);
            $window.open(
                `${HPConfig.applyLink}application-results/${input}`,
                '_blank',
            );
        } else {
            // Click handler for the 'Get Approved' button
            const label = (vm.kbygModalOpen === true) ? 'KBYG' : 'Leads';
            $analytics.eventTrack('Get Approved Click', { category: params.source, label });
            $window.open(
                vm.leadData.ApplicationLink,
                '_blank',
            );
        }
    };

    vm.submitAnApplicationClick = function () {
        // Click handler for the 'submit an application' text link in the next steps section of kbyg results
        const category = (vm.kbygModalOpen === true) ? 'Modal: Next Steps' : 'Module: Next Steps';
        const label = (vm.kbygModalOpen === true) ? 'KBYG' : 'Leads';
        $analytics.eventTrack('Submit an application', { category, label });
        $window.location.href = vm.leadData.ApplicationLink;
    };

    vm.checkPropertyOwner = function () {
        return ((vm.leadData.Owner1LastName !== null || vm.leadData.Owner1LastName !== undefined) ||
            (vm.leadData.Owner1FirstName !== null || vm.leadData.Owner1FirstName !== undefined) ||
            (vm.leadData.AllOwners !== null || vm.leadData.AllOwners !== undefined));
    };

    vm.displayNoPropertyOwnerMessage = function () {
        return (!vm.leadData.Owner1LastName && !vm.leadData.Owner1FirstName && !vm.leadData.AllOwners);
    };

    vm.displayPropertyOwnerCounty = function () {
        if (vm.leadData.Owner1LastName === null || vm.leadData.Owner1LastName === undefined || vm.leadData.Owner1LastName === '') {
            return true;
        }
        return false;
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
   =            Private Functions            =
   ======================================== */

    function init() {
        trackKbygModal();

        if (vm.kbygModalOpen === false) {
            prequalId = $stateParams.prequalId;
        } else {
            prequalId = $scope.kbygModal.kbygResponse.PreQualID;
        }

        if (prequalId === undefined) {
            // This may happen for some kbyg results
            vm.leadData = $scope.kbygModal.kbygResponse;
            setLeadResult();
        } else if ($scope.kbygModal === null || $scope.kbygModal === undefined) {
            vm.loading = true;
            LeadFactory.getLeadData(prequalId).then((leadData) => {
                vm.leadData = leadData;
                setLeadResult();
                vm.loading = false;
            });
        } else {
            vm.leadData = $scope.kbygModal.kbygResponse;
            setLeadResult();
        }

        // TODO: Remove after refactoring system to load rules on page refresh.
        UserData.getUserData().then((response) => {
            if (response.IsSuspendedCompliance === true) {
                UiDisplayFactory.setDisplayRule('suspendedCompliance', response.IsSuspendedCompliance);
                vm.displayActions = false;
            }
        });
    }

    function trackKbygModal() {
        const kbygModal = ModalService.getLgModal();
        if (kbygModal !== undefined && kbygModal !== null) {
            vm.kbygModalOpen = true;
        } else {
            vm.kbygModalOpen = false;
        }
    }

    function setLeadResult() {
        let result = '',
            enteredAddress = '';

        vm.isFullPrequal = !!vm.leadData.RAApplicationID;

        if (vm.isFullPrequal) {
            switch (vm.leadData.PrequalResultDecisionTypeID) {
            case 1:
            case 2: result = 'Green'; break;
            case 0:
            case 3: result = 'Yellow'; break;
            case 4: result = 'Red'; break;
            default: result = 'Undetermined'; break;
            }
        } else if (!!vm.leadData.PreQualResult && typeof (vm.leadData.PreQualResult) === 'string') {
            // Perform a case insensitive check
            switch (vm.leadData.PreQualResult.toLowerCase()) {
            case 'pass':
                result = 'Green';
                break;
            case 'borderline':
            case 'maybe':
            case 'passconditionally':
                result = 'Yellow';
                break;
            case 'maybenoliens':
                result = 'MaybeNoLiens';
                break;
            case 'fail':
                result = 'Red';
                break;
            case 'outofbounds':
                result = 'OutOfBounds';
                break;
            case 'duplicate':
                result = 'Duplicate';
                break;
            case 'pvnotfound':
                result = 'PVNotFound';
                break;
            default:
                result = 'Undetermined';
                break;
            }
        }

        if (vm.leadData.Address) {
            // (ajt 4/15/2016) - Added GA for KBYG Results
            if (vm.kbygModalOpen === true && !vm.leadData.isZipCodeOutOfBounds) {
                enteredAddress = `${vm.leadData.Address.Address1} ${vm.leadData.Address.Address2 ? `${vm.leadData.Address.Address2} ` : ''}${vm.leadData.Address.City} ${vm.leadData.Address.State} ${vm.leadData.Address.ZIPCode}`;
                $analytics.eventTrack(result, { category: 'KBYG', label: enteredAddress });
            }
        }

        vm.leadResult = result;
        vm.primaryInformationLoading = false;
        LeadFactory.getLeadMessages(prequalId, vm.leadData.OrganizationId).then((message) => {
            if (message !== undefined && message !== null) {
                vm.showLeadMessage = message.show;
                vm.leadMessage = message;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/lead/leadController.js